import { Injectable } from '@angular/core';
import { FacettenUrlService } from '../facetten.url.service';

@Injectable({
  providedIn: 'root'
})
export class UnterrichtszeitUrlService extends FacettenUrlService {
  public static URL_PARAMETER = 'uz';

  constructor() {
    super(UnterrichtszeitUrlService.URL_PARAMETER, 'uz');
  }
}
